import userIcon from "../../../assets/images/userIcon.svg";
import { extractGradientColors } from "../../../general";
import { BrandTheme, HelphubStyleConfig } from "../CustomHelpHub.type";
import { formatDate, getColorVariations, hexToGlassColor } from "./helperfunction";

interface QuestThemeData {
  accentColor?: string;
  borderRadius?: string;
  buttonColor?: string;
  images?: string[];
}

type Props = {
  message: {
    senderRole: "ASSISTANT" | "USER" | "ADMIN" | "SYSTEM";
    content: string;
    timestamp: string;
  };
  index: number;
  fontSize: number | string;
  QuestThemeData?: QuestThemeData;
  BrandTheme?: BrandTheme;
  styleConfig?: HelphubStyleConfig;
};

const HandleUserChat = ({
  message,
  index,
  fontSize,
  QuestThemeData,
  styleConfig,
  BrandTheme,
}: Props) => {


  const wrapLinksInText = (text: string, index: number) => {
    // const urlRegex = /(\bhttps?:\/\/[^\s]+)/gi;
    const urlRegex = /(\bhttps?:\/\/[^\s)]+)/gi; // This stops at ')' in URLs

    const parts = text.split(urlRegex);

    const wrappedText = parts.map((part, index) => {
      if (urlRegex.test(part)) {
        const cleanUrl =
          part.endsWith(".") ||
            part.endsWith(")") ||
            part.endsWith("]") ||
            part.endsWith("}")
            ? part?.slice(0, -1)
            : part;

        return (
          <a
            key={index}
            href={cleanUrl}
            target="_blank"
            style={{ fontSize: fontSize }}
          >
            {cleanUrl}
          </a>
        );
      }
      return part;
    });

    return (
      <p
        style={{
          color:
            styleConfig?.Chat?.SenderMessage?.color
            ||
            BrandTheme?.titleColor
        }}
        key={index}
      >
        {wrappedText}
      </p>
    );
  };


  function formatMessage(message?: string) {
    const messageParagraphs = message?.split("\n").map((line, index) => wrapLinksInText(line, index));
    return messageParagraphs;
  }

  let color = BrandTheme?.primaryColor || QuestThemeData?.accentColor;
  if (color?.includes("gradient")) {
    color = extractGradientColors(color);
  }

  return (
    <>
      <div key={index} style={{ width: "100%" }}>
        <div
          className={`custom-message ${
            message?.senderRole === "USER" ? "custom-sender-role" : "receiver-role"
            }`}
        >
          {message?.content?.includes("https://quest-media-storage-bucket") ||
            message?.content?.includes("https://pin.questprotocol.xyz/ipfs") ? (
            <div className="chat-coversion-img">
              <img src={message?.content} alt="" />
            </div>
          ) : (
            <>{formatMessage(message?.content)}</>
          )}
        </div>
      </div>
    </>
  );
};

export default HandleUserChat;
